import clsx from 'clsx'
import { htmlReactParse } from 'shared-code/html'
import Linked from 'shared-components/service/Linked'
import SocialIcon from 'shared-components/service/SocialIcon'
import { DSAuthorNewPage, DSPostShortWithAuthor } from 'shared-definitions/types'
import ArrowUp from 'shared-svg/ArrowShare.svg'
import SoundLines from 'shared-svg/SoundLines.svg'
import SoundLinesSecond from 'shared-svg/SoundLinesSecond.svg'
import SoundLinesThird from 'shared-svg/SoundLinesThird.svg'
import PostRow from '../posts/PostRow'
import AppImage from '../ui/AppImage'
import LoadMoreList from '../ui/LoadMoreList'
import NumbersList from '../ui/NumbersList'
import styles from './AuthorNewTemplate.module.css'

interface AuthorNewTemplateProps {
  page: DSAuthorNewPage
  pageLoader: (page: number, perPage: number) => Promise<DSPostShortWithAuthor[]>
}

const AuthorNewTemplate: React.VFC<AuthorNewTemplateProps> = ({ page, pageLoader }) => (
  <div>
    <section className={clsx(styles.pageWrapper, styles.hero)}>
      <SoundLines className={styles.heroBg} />
      {page.author.image && (
        <AppImage
          layout="raw"
          image={page.author.image}
          className={styles.heroImg}
          sizes={[{ bp: 'lg', val: 144 }, 88]}
        />
      )}
      <h1 className={styles.heroTitle}>{page.author.name}</h1>
      {page.author.description && (
        <div className={styles.heroDescription}>{htmlReactParse(page.author.description)}</div>
      )}
    </section>
    {page.numbers.length > 0 && (
      <section className={clsx(styles.pageWrapper)}>
        <NumbersList className={styles.numbersList} numbers={page.numbers} />
      </section>
    )}
    {page.choice && (
      <section className={styles.choiceWrapper}>
        <SoundLinesSecond className={styles.choiceBgMobile} />
        <SoundLinesThird className={styles.choiceBgDesktop} />
        <div className={clsx(styles.choice, styles.pageWrapper)}>
          <h2 className={styles.choiceTitle}>{page.choice.title}</h2>
          {page.choice.image && (
            <div className={styles.choiceImage}>
              <AppImage
                layout="responsive"
                image={page.choice.image}
                sizes={[{ bp: 'lg', val: 550 }, 'min(100vw, rem(550))']}
              />
            </div>
          )}
          <div className={styles.choiceDescription}>{page.choice.short}</div>
        </div>
      </section>
    )}
    {page.author.socials.length > 0 && (
      <section className={clsx(styles.pageWrapper2, styles.socials)}>
        <SoundLinesSecond className={styles.socialsBgMobile} />
        <SoundLinesThird className={styles.socialsBgDesktop} />
        <h2 className={styles.socialsTitle}>{page.labels.connect}</h2>
        <div className={styles.socialsList}>
          {page.author.socials.map((item, index) => (
            <Linked
              key={index}
              className={styles.socialOne}
              {...item.pLink}
              aria-label={item.title}
            >
              <SocialIcon icon={item.icon} className={styles.socialIcon} />
              <span className={styles.socialLabel}>{item.title}</span>
              <ArrowUp className={styles.socialIconShare} />
            </Linked>
          ))}
        </div>
      </section>
    )}
    {page.posts.items.length > 0 && (
      <section className={clsx(styles.pageWrapper, styles.recent)}>
        <h2 className={styles.recentTitle}>{page.labels.recentArticles}</h2>
        <LoadMoreList
          autoload
          render={(item: DSPostShortWithAuthor, index) => <PostRow key={index} post={item} large />}
          className={styles.recentList}
          initial={page.posts}
          loader={pageLoader}
        />
      </section>
    )}
  </div>
)
export default AuthorNewTemplate
